import { ApiSavedSearchUnsaved } from 'api/types/ApiSavedSearch';
import { del, postJson } from 'utils/http';

export function saveSearch({
  text,
  filters,
  location,
  index,
  radius,
}: ApiSavedSearchUnsaved) {
  return postJson('/data/saved-searches', {
    text,
    filters,
    radius,
    location,
    index,
  });
}

export function unsaveSearch(searchId: string) {
  return del(`/data/saved-searches/${searchId}`);
}
